import { render, staticRenderFns } from "./Loja.vue?vue&type=template&id=9e3a52aa&scoped=true&"
import script from "./Loja.vue?vue&type=script&lang=js&"
export * from "./Loja.vue?vue&type=script&lang=js&"
import style0 from "./Loja.vue?vue&type=style&index=0&id=9e3a52aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e3a52aa",
  null
  
)

export default component.exports